export default "__VITE_ASSET__hai7dak$__"